import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBomDetails } from "../store/dataSlice";
import { Table, Card, Button } from "antd";
const DetailTable = ({ record }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getBomDetails({ bom_id: record.bom_id }));
  }, [record]);
  const data = useSelector((state) => state.rawMaterial.data?.bomDetailList);

  const columns = [
    {
      title: <span className="text-gray-500">Material Grade</span>,
      dataIndex: ["Product", "MaterialGrade", "number"],
      width: 150,
    },
    {
      title: <span className="text-gray-500">Product</span>,
      dataIndex: ["Product"],
      render: (product) => (
        <>
          <div>
            <span className="text-gray-500">Part Name:</span>{" "}
            {product.part_name}
          </div>
          <div>
            <span className="text-gray-500">Description:</span>{" "}
            {product.description}
          </div>
        </>
      ),
    },

    {
      title: <span className="text-gray-500">Quantity</span>,
      dataIndex: "quantity",
      width: 150,
    },
    {
      title: <span className="text-gray-500">Thickness</span>,
      dataIndex: ["Product", "thickness"],
    },
    {
      title: <span className="text-gray-500">Weight</span>,
      dataIndex: ["Product", "weight"],
    },
    {
      title: <span className="text-gray-500">Unit</span>,
      dataIndex: ["Product", "unit_measurement"],
    },
    {
      title: <span className="text-gray-500">Description</span>,
      dataIndex: "description",
    },
    {
      title: <span className="text-gray-500">Date</span>,
      dataIndex: "date",
    },
  ];

  return (
    <>
      <Card
        style={{ width: "400px" }}
        className="text-xl font-semibold mb-8 bg-pink-50 flex-col "
      >
        <h2>BOM NUMBER : {data?.bom_number}</h2>
        <h2>ORDER NUMBER : {data?.order_number}</h2>
        <h2>
          Date: {data && data.createdAt ? data.createdAt.split("T")[0] : "N/A"}
        </h2>
      </Card>

      <Table
        columns={columns}
        dataSource={data?.BOMDetails}
        pagination={false}
      ></Table>
      <div className="flex justify-end">
        <Button type="primary" className="mt-4">
          Confirm
        </Button>
        <Button type="primary" className="mt-4 ml-4">
          Reject
        </Button>
      </div>
    </>
  );
};

export default DetailTable;
